import { useBuyPanelsStore } from "../store";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/Card";

export default function PaymentFrequencySelector() {
  const paymentType = useBuyPanelsStore((state) => state.paymentType);
  const setPaymentType = useBuyPanelsStore((state) => state.setPaymentType);

  return (
    <Card className="bg-brand-neutral-800 border-zinc-700 mb-5 py-0">
      <CardContent className="p-4 md:p-6">
        <h3 className="font-semibold text-white mb-4">Payment Frequency</h3>
        <div className="flex flex-col space-y-3">
          <div className="flex items-center space-x-2">
            <input
              type="radio" 
              name="paymentType"
              value="once" 
              id="pay-once" 
              checked={paymentType === "once"}
              onChange={() => setPaymentType("once")}
              className="w-4 h-4 text-brand-orange-500 bg-brand-neutral-800 border-zinc-700" 
            />
            <Label htmlFor="pay-once" className="text-white cursor-pointer">One off</Label>
          </div>
          <div className="flex items-center space-x-2">
            <input
              type="radio" 
              name="paymentType"
              value="recurring" 
              id="recurring-payment" 
              checked={paymentType === "recurring"}
              onChange={() => setPaymentType("recurring")}
              className="w-4 h-4 text-brand-orange-500 bg-brand-neutral-800 border-zinc-700" 
            />
            <Label htmlFor="recurring-payment" className="text-white cursor-pointer">Recurring payment</Label>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}